import Button from "@/components/Button"
import Modal from "@/components/modals/Modal"
import { ModalBody, ModalContent, ModalFooter } from "@nextui-org/modal"
import { ReactComponent as LinkIcon } from "@/icons/link-icon.svg"
import { ReactComponent as FileIcon } from "@/icons/file-icon.svg"
import { ReactComponent as FilesIcon } from "@/icons/files-icon.svg"

type Props = {
  isOpen: boolean
  onClose: () => void
  onExportLink: () => void
  onExportSingle: () => void
  onExportAll: () => void
}

const ExportOptionsModal = ({
  isOpen,
  onClose,
  onExportLink,
  onExportSingle,
  onExportAll,
}: Props) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent>
        {(onClose) => (
          <>
            <ModalBody>
              <h2 className="type-body-xl font-bold text-white">Export Options</h2>
              <div className="mt-6 space-y-4">
                <button
                  className="flex w-full items-center gap-x-3 rounded-plus border border-jaguar bg-dark-jaguar p-3 text-left transition-colors hover:border-silver"
                  onClick={() => {
                    onExportLink()
                    onClose()
                  }}
                >
                  <LinkIcon className="h-5 w-5 text-brightest-blue" />
                  <div>
                    <div className="type-body-sm font-bold">
                      Export Active Profile as Shareable Link
                    </div>
                    <div className="type-body-xs text-silver">
                      Generate a link to share your current profile
                    </div>
                  </div>
                </button>

                <button
                  className="flex w-full items-center gap-x-3 rounded-plus border border-jaguar bg-dark-jaguar p-3 text-left transition-colors hover:border-silver"
                  onClick={() => {
                    onExportSingle()
                    onClose()
                  }}
                >
                  <FileIcon className="h-5 w-5 text-brightest-blue" />
                  <div>
                    <div className="type-body-sm font-bold">Export Active Profile as a File</div>
                    <div className="type-body-xs text-silver">
                      Download your current profile as a file
                    </div>
                  </div>
                </button>

                <button
                  className="flex w-full items-center gap-x-3 rounded-plus border border-jaguar bg-dark-jaguar p-3 text-left transition-colors hover:border-silver"
                  onClick={() => {
                    onExportAll()
                    onClose()
                  }}
                >
                  <FilesIcon className="h-5 w-5 text-brightest-blue" />
                  <div>
                    <div className="type-body-sm font-bold">Export all Profiles as a File</div>
                    <div className="type-body-xs text-silver">
                      Download all your profiles as a single file
                    </div>
                  </div>
                </button>
              </div>
            </ModalBody>
            <ModalFooter className="gap-x-0">
              <Button
                className="-mr-5"
                theme="none"
                size="sm"
                outline={false}
                solid={true}
                full={false}
                onClick={onClose}
              >
                Cancel
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  )
}

export default ExportOptionsModal
